module.exports = __webpack_public_path__ + "img/menu_burger.ce0998b6.svg";